<template>
  <circle-select
    :value="value"
    :options="themeOptions"
    aria-value="theme"
    :theme-value="true"
    :columns="3"
    @input="$emit('input', $event)"
  >
    <!-- @remove-theme="handleRemoveTheme" -->
  </circle-select>
</template>

<script>
import CircleSelect from '../dropdown/CircleSelect.vue'
export default {
  components: {
    CircleSelect
  },
  props: {
    // FIXME
    /* eslint-disable vue/require-default-prop */
    value: {
      type: String,
      required: false
    },
    /* eslint-enable vue/require-default-prop */
    themes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      availableThemes: [
        {
          label: 'Candy Hearts',
          value: 'Candy Hearts',
        },
        {
          label: 'Little Hearts',
          value: 'Little Hearts',
        },
        {
          label: 'Love',
          value: 'Love',
        },
      ]
    }
  },
  computed: {
    themeOptions() {
      const themes = this.themes
      const availableThemes = availableThemes
      
      let result = themes.filter(item => item.optionImage || item.themeImage)
        .map(e => ({
          label: e.theme,
          value: e.theme,
          image: e.optionImage || e.themeImage || null,
          style: {
            'border-radius': '0',
            'border': 'none',
            'width': 'fit-content',
            'height': '180px',
            'display': 'flex',
            'align-items': 'center'
          }
        }))
      return result
    }
  }
}
</script>
